/**
  * @class meleMap_area
  * @description
  *
  * # Purpose
  * Implaments AREA shape
  *
  * # Use
  *
  * # Implementation notes
  *
  */

import meleMap_shape from '../meleMap_shape.js'
const melemap_lib = require('../meleMap_lib.js')

export default class meleMap_area extends meleMap_shape {
  static shape() { return 'A' }

  redrawShape() {
    if(this._points.length<2) { return this.deleteShape() }

    if(this._shape) {
      this._shape.setLatLngs(this._points)
    }else {
      this._shape = L.polygon(this._points, { pane: this._props.pane || melemap_lib.DEFAULT_PANE }).addTo(this._map)
    }

    this.configureShape()
  }

  calculateCenter() {
    if(this._points.length<2) return(this._center = null)

    if(this._points.length==2) {
      return(this._center = melemap_lib.intermediatePoint(this._points[0], this._points[1], 0.5))
    }

    const points = this._points.map(p=>Array.isArray(p)?p:[p.lat, p.lng])
    const length = points.length

    let twoTimesSignedArea = 0
    let cxTimes6SignedArea = 0
    let cyTimes6SignedArea = 0

    const x = function (i) { return points[i % length][0] }
    const y = function (i) { return points[i % length][1] }

    for (let i = 0; i < points.length; i++) {
      const twoSA = x(i)*y(i+1) - x(i+1)*y(i)
      twoTimesSignedArea += twoSA
      cxTimes6SignedArea += (x(i) + x(i+1)) * twoSA
      cyTimes6SignedArea += (y(i) + y(i+1)) * twoSA
    }
    const sixSignedArea = 3 * twoTimesSignedArea

    this._center = [cxTimes6SignedArea / sixSignedArea, cyTimes6SignedArea / sixSignedArea]
    return this._center
  }

  shape() {
    return 'A,'+this._points.map(point=>melemap_lib.point2geohash(point)).join(',')
  }

  addPoint(point) {
    this._points.push(point)
    delete this._center
    this.redrawShape()
    this.redrawMarker()

    // prepare guiding line
    const last_point = this._points[this._points.length-1]
    if(this._guide) {
      this._guide.setLatLngs([last_point, last_point])
    }else {
      this._guide = L.polyline([last_point, last_point], { pane: melemap_lib.DRAW_PANE }).addTo(this._map)
    }
    this._guide._path.setAttribute('marker', 'guide')
  }

  guide(point) {
    if(this._guide) {
      const last_point = this._points[this._points.length-1]
      if(!point) point = last_point
      this._guide.setLatLngs([last_point, point])
    }
  }
} // class meleMap_area
